import { ref, type Ref } from "vue";


export default class EditorIframeApiService {
  static status: Ref<null | 'progress' | 'finally'> = ref(null);
  static retry: Ref<{ count: number, tryNumber: number }> = ref({
    count: 3,
    tryNumber: 0,
  });

  constructor() { };

  async load(designEditorUrl: string | null, link: string | null, loadHandler: () => void, scriptElement?: Ref<HTMLScriptElement | null>) {
    if (EditorIframeApiService.retry.value.tryNumber >= EditorIframeApiService.retry.value.count) {
      EditorIframeApiService.status.value = null;
      return;
    }

    EditorIframeApiService.status.value = 'progress';
    EditorIframeApiService.retry.value.tryNumber += 1;

    if (scriptElement?.value) {
      scriptElement.value.remove();
      scriptElement.value = null;
    }
    
    const newScriptUrl = link ? link : `${designEditorUrl}/Resources/Generated/IframeApi.js`;

    const newScript = document.createElement('script');
    newScript.id = 'CcIframeApiScript';
    newScript.type = 'text/javascript';
    newScript.src = newScriptUrl;
    newScript.async = true;
    newScript.addEventListener('load', () => {
      if (designEditorUrl) {
        CustomersCanvas.IframeApi.editorUrl = designEditorUrl;
        CustomersCanvas.IframeApi.preload();
        EditorIframeApiService.status.value = 'finally';
      } else {
        this.load(designEditorUrl, link, loadHandler, scriptElement);
      }
      loadHandler();
    });
    document.head.appendChild(newScript);
  }
}